import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { CheckIncustomerAction } from "stores/CheckIn/CheckInCustomerAction";


const mapStateToProps = (state) => {
    return {
        getcheckinCustomerbyid:state.CheckIncustomerData.getcheckinCustomerbyid,
        CheckIncustomerList: state.CheckIncustomerData.CheckIncustomerList,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getCheckinCustomerbyidData:CheckIncustomerAction.getCheckinCustomerbyidData,
    CheckIncustomerAction: CheckIncustomerAction.getNavigationData,
  postcheckindetailsData:CheckIncustomerAction.postcheckindetailsData,
 
}, dispatch);

const CheckInCustomerDetailsStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default CheckInCustomerDetailsStore;